import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import { Link } from "react-router-dom";

const Form = () => {
  return (
    <React.Fragment>
      <SEO title="Fill Online Registration Form | DMBD 2025" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Fill Online Registration Form"
        content="Registration"
        contentTwo="Fill Online Registration Form"
        linkage="/registration"
      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div classNameName="entry-header">
          <div className="reg-form">
            <iframe   
              src="https://wj.qq.com/s2/24999705/u6hr/"
              // frameBorder={0}
              // allowFullSreen
            ></iframe>
          </div>
          <div className="back">
            <Link
              className="btn btn-primary btn-hover-secondary  mt-s"
              to={process.env.PUBLIC_URL + "/registration"}
            >
              Back to Registration page
            </Link>
          </div>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classNameOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Form;
